// ══════════════════════════════════════════════════════════════════════════
// eventoSeleccionCondimento(condimentoHTML)
// ══════════════════════════════════════════════════════════════════════════

// 1. Obtenemos los datos iniciales:
//    - seccionKey: identificador de la sección (ej: "tamano", "ingredientes")
//    - condimentoSeleccionado: el objeto del condimento con su id, titulo, precio, etc.
//    - estaSeleccionado: true si el condimento ya tiene la clase "seleccionado", false si no

// 2. Preguntamos: ¿Es sección de Tamano (seccionKey == "tamano")?
//    Si: Procedemos con lógica especial de Tamano
//        
//        2.1. Preguntamos: ¿El condimento está seleccionado (estaSeleccionado == true)?
//             
//             Si: El cliente quiere DESELECCIONAR el Tamano actual
//                 - Intentamos eliminar el Tamano del Map (opcionesSeleccionadas)
//                 - Preguntamos: ¿Si lo eliminamos, la sección todavía tiene el mínimo requerido de condimentos?
//                   Si: Está permitido deseleccionar
//                       → Mantenemos eliminado del Map
//                       → Actualizamos HTML: removemos clase "seleccionado" y ponemos icono OFF
//                   No: NO está permitido deseleccionar (no cumple mínimo)
//                       → Revertimos: volvemos a agregar al Map
//                       → NO tocamos el HTML (sigue mostrando como seleccionado)
//             
//             No: El cliente quiere SELECCIONAR un nuevo Tamano
//                 - Guardamos el nuevo Tamano en this.sizeSeleccionado
//                 - Buscamos si hay un Tamano anterior en el Map
//                 - Eliminamos el Tamano anterior del Map (si existe)
//                 - Agregamos el nuevo Tamano al Map
//                 - IMPORTANTE: Reestructuramos TODAS las secciones con estructurarContruccion()
//                   (Esto recalcula precios y estados de todos los condimentos según el nuevo Tamano)
//                 
//                 - Actualizamos HTML del nuevo Tamano:
//                   → Agregamos clase "seleccionado" y ponemos icono ON
//                 
//                 - Preguntamos: ¿Existe un Tamano anterior?
//                   Si: Buscamos ese condimento en el HTML y lo deseleccionamos
//                       → Removemos clase "seleccionado" y ponemos icono OFF
//                   No: No hacemos nada
//                 
//                 - Ahora viene lo importante: Actualizamos TODAS las demás secciones
//                   (ingredientes, bordes, extras, etc. - excepto "tamano" y "subcarrito")
//                   
//                   Por cada sección hacemos:
//                   - Buscamos el HTML de esa sección en el DOM
//                   - Obtenemos todos los condimentos HTML de esa sección
//                   
//                   Por cada condimento hacemos:
//                   - Obtenemos su objeto condimento de seccionesConstruccion
//                   - Verificamos si está seleccionado en el HTML (tiene clase "seleccionado")
//                   - Calculamos su nuevo estado según el Tamano nuevo usando estadoCondimentoConstruccion()
//                     (esto retorna: "seleccionado", "desactivado" o "")
//                   
//                   - Comparamos el estado HTML con el estado calculado:
//                   
//                     Caso A: Estaba seleccionado en HTML PERO ahora está desactivado
//                             (El condimento ya no está disponible para este Tamano)
//                             → Eliminamos del Map
//                             → Deseleccionamos en HTML (quitar clase, poner icono OFF)
//                             → Buscamos el SIGUIENTE condimento disponible en la lista
//                             → Preguntamos: ¿Encontramos un siguiente?
//                               Si: Agregamos el siguiente al Map
//                                   Seleccionamos el siguiente en HTML (agregar clase, poner icono ON)
//                               No: No hacemos nada (queda sin selección)
//                     
//                     Caso B: El estado calculado dice "seleccionado" PERO NO está en el Map
//                             (Está desincronizado, debería estar seleccionado)
//                             → Agregamos al Map
//                             → Seleccionamos en HTML (agregar clase, poner icono ON)
//                     
//                     Caso C: El estado calculado dice "" (vacío) PERO SÍ está en el Map
//                             (Está desincronizado, NO debería estar seleccionado)
//                             → Eliminamos del Map
//                             → Deseleccionamos en HTML (quitar clase, poner icono OFF)
//                     
//                     Caso D: Está sincronizado correctamente
//                             → Solo actualizamos el precio en el HTML
//                   
//                   - Finalmente actualizamos la clase "desactivado":
//                     Si el estado calculado es "desactivado": agregamos clase "desactivado"
//                     Si no: removemos clase "desactivado" (si la tenía)
//    
//    No: Es OTRA SECCIÓN (ingredientes, bordes, extras, etc.)
//        
//        2.2. Preguntamos: ¿El condimento está seleccionado (estaSeleccionado == true)?
//             
//             Si: El cliente quiere DESELECCIONAR este condimento
//                 - Eliminamos temporalmente el condimento del Map
//                 - Preguntamos: ¿Si lo eliminamos, la sección todavía tiene el mínimo requerido?
//                   Si: Está permitido deseleccionar
//                       → Mantenemos eliminado del Map
//                       → Actualizamos HTML: removemos clase "seleccionado" y ponemos icono OFF
//                   No: NO está permitido deseleccionar (no cumple mínimo)
//                       → Revertimos: volvemos a agregar al Map
//                       → NO tocamos el HTML (sigue mostrando como seleccionado)
//             
//             No: El cliente quiere SELECCIONAR este condimento
//                 - Obtenemos todos los condimentos actuales de esta sección (ANTES de agregar el nuevo)
//                 - Agregamos el nuevo condimento al Map
//                 - Preguntamos: ¿Después de agregar, la sección todavía cumple el máximo permitido?
//                   Si: Está permitido agregar sin problemas
//                       → Solo actualizamos HTML del nuevo: agregamos clase "seleccionado" y ponemos icono ON
//                   No: Excedimos el máximo permitido, necesitamos REEMPLAZAR
//                       → Tomamos el PRIMER condimento que estaba seleccionado ANTES
//                       → Eliminamos ese primer condimento del Map
//                       → Buscamos ese condimento en el HTML y lo deseleccionamos
//                         (removemos clase "seleccionado" y ponemos icono OFF)
//                       → Actualizamos HTML del nuevo: agregamos clase "seleccionado" y ponemos icono ON

if (!customElements.get("product-info")) {
  customElements.define(
    "product-info",
    class ProductInfo extends HTMLElement {
      constructor() {
        super();
        this.condimentosHTML = null;
        this.seleccionCondimentos = null;
        this.producto = null;
        this.sizeSeleccionado = null;
        this.metafield = null;
        this.sucursal = GestionSucursales.corroborarInfoShopify(
          window.sucursales,
          JSON.parse(localStorage.getItem("sucursal-informacion"))
        );
        this.precio = 0;
        this.precio_comparacion = 0;
        this.coleccionesReconstruccion = [];
        this.cualSeccionExtrasEs = "";
        this.ladoPizza = "";
        this.tipoProceso = "";

        this.etiquetaPrecioComparacion = null;
        this.productoSeleccionadoRamaPrincipal = null;

        this.itemsSeleccionadoPostres = [];
        this.itemsSeleccionadogaseosas = [];
        this.cantidadPrecioCarrito = null;
        this.cantidadPrecioHazUnPedido = null;
        this.cantidadPrecioConjuntoBase = null;
        this.productoComplementariosPrimario = "Postres";
        this.productoComplementariosSecundario = "Gaseosas";
        this.btnsElegirMitadYMitad = null;
        this.infoPizzaLIMM = null;
        this.infoPizzaLDMM = null;
        this.productosLIMM = [];
        this.productosLDMM = [];

        // Obtiene la información del producto desde localStorage
        this.productoInfo =
          JSON.parse(localStorage.getItem("phpp-productoData")) || null;
        this.estadoTrabajoSobreProducto = null;
        this.carritoShopify = null;
        this.precitoTotalCarrito = 0;
        this.elCarritoFueActualizado = false;
        this.productosComplementarios = [];
        this.estadoTrabajoComplementarios = "";
        this.esPizza = false;
      }

      async connectedCallback() {
        MensajeCargaDatos.mostrar('Procesando Informacion ...');
        await this.construccionObjetoProducto();
        await this.inicializarReferencias();
        this.inicializarEventos();
        this.btnAgregarCarrito.addEventListener('click', this.procesoBotonesInferiores.bind(this, 'agregarcarrito'));
        this.construccionSecciones();
        MensajeCargaDatos.ocultar();
      }

      async inicializarReferencias() {

        // Elementos DOM - Postres
        this.estadoVacioContenedorPostres = this.querySelector(
          "#phpm-vacio-extras-especiales-postres"
        );
        this.estadoItemsContenedorPostres = this.querySelector(
          "#phpm-extras-especiales-postres"
        );
        this.anadirMasContenedorPostres = this.querySelector(
          "#phpm-btn-anadir-extras-postres"
        );
        this.seccionModalExtrasPostres = this.querySelector(
          "#phpp-modal-productos-postres"
        );
        this.btnsEliminarExtrasPostres = null;

        // Elementos DOM - Gaseosas y Cervezas
        this.estadoVacioContenedorGaseosas = this.querySelector(
          "#phpm-vacio-extras-especiales-gaseosas"
        );
        this.estadoItemsContenedorGaseosas = this.querySelector(
          "#phpm-extras-especiales-gaseosas"
        );
        this.anadirMasContenedorGaseosas = this.querySelector(
          "#phpm-btn-anadir-extras-gaseosas"
        );
        this.seccionModalExtrasGaseosas = this.querySelector(
          "#phpp-modal-productos-gaseosas"
        );
        this.btnsEliminarExtrasGaseosas = null;

        // Elementos DOM - Modal y Controles
        this.btnSeccionModalSalir = this.querySelector("#phppm-btn-salir");
        this.btnSeccionModalGuardar = this.querySelector("#phppm-btn-guardar");
        this.cantidadProductoGeneralEtiqueta = this.querySelector(
          "#phpd-cantidad-general"
        );
        this.btnsContenedorCantidad = this.querySelectorAll(
          ".pmph-cantidad-selector-button"
        );

        // Inicialización de valores
        this.cantidadProductoGeneralEtiqueta.innerHTML = 1;

        await this.creacionProductosComplementarios(
          this.productoComplementariosPrimario
        );
        await this.creacionProductosComplementarios(
          this.productoComplementariosSecundario
        );
        // REFERENCIAS ELEMENTOS
        this.btnHazUnPedido = this.querySelector("#phpm-btn-haz-un-pedido");
        this.btnAgregarCarrito = this.querySelector(
          "#phpm-btn-agregar-carrito"
        );

        this.etiquetaAgregarCarrito = this.querySelector(
          "#phpp-etiqueta-agregarcarrito"
        );
        this.etiquetaACPrecioComparacion = this.querySelector(
          "#phpp-agregarcarrito-precio-comparacion"
        );

        this.etiquetaHazUnPedido = this.querySelector(
          "#phpp-etiqueta-hazunpedido"
        );
        this.btnVolverAtras = this.querySelector(".pmph-volver-atras");
        this.modalProductoExtras = this.querySelector(
          "#pmph-modal-productos-extras"
        );
        this.tipoProducto = localStorage.getItem("phpp-tipo-producto") || "";

        // PRODUCTO ESPECIAL (MITAD & MITAD)
        // (LIMM) Lado Izquierdo Mitad y Mitad - (LDMM) Lado Derecho Mitad y Mitad
        this.seccionVerTodosMitadyMitad = this.querySelector(
          "#pmph-seleccion-pizza-mitadymitad"
        );
        this.imagenProductoLIMM = this.querySelector(
          "#phmp-imagen-producto-limm"
        );
        this.imagenProductoLDMM = this.querySelector(
          "#phmp-imagen-producto-ldmm"
        );
        this.imagenProductoBtnLIMM = this.querySelector(
          "#phpm-btn-imagen-limm"
        );
        this.imagenProductoBtnLDMM = this.querySelector(
          "#phpm-btn-imagen-ldmm"
        );
        this.seccionImagenMitadYMitad = this.querySelector(
          "#phmp-contenido-ver-producto-complejo"
        );
        this.seccionBaseLadosMitadYMitad = this.querySelector(
          "#phpp-modal-productos-mitadYmitad"
        );
        this.seccionModalExtrasLIMM = this.querySelector(
          "#phpp-items-mitadYmitad-limm"
        );
        this.seccionModalExtrasLDMM = this.querySelector(
          "#phpp-items-mitadYmitad-ldmm"
        );

        this.btnModalLIMM = this.querySelector("#phpm-btn-limm");
        this.btnModalLDMM = this.querySelector("#phpm-btn-ldmm");

      }

      async construccionObjetoProducto() {

        // CONSTRUCCION DEL OBJETO PRODUCTO
        this.producto = await GestorProductos.getProductoPorTitulo(this.getAttribute('data-handle'));
        console.log(this.producto);
        this.producto.metafield.secciones = SeleccionCondimentos.objetoASeccionesCondimentos(this.producto.metafield.secciones);
        this.seleccionCondimentos = new SeleccionCondimentos({ secciones: this.producto.metafield.secciones });

        // VERIFICAR URL -> SIZE PRESELECCIONADO
        var urlNav = new URL(window.location.href).searchParams.get("size") || null;
        if (this.producto.colecciones.includes("Pizza") ||
          this.producto.colecciones.some(coleccion => coleccion.includes("Pizza"))) {
          if (urlNav == null) {
            console.log("No hay size seleccionado");
            this.sizeSeleccionado =
              this.producto.metafield.secciones.find(
                (seccion) => seccion.key == "tamano"
              )?.productos[0] || null;
          } else {
            this.sizeSeleccionado = this.producto.metafield.secciones.find(
              (seccion) => seccion.key == "tamano"
            )?.productos.find(
              (producto) => producto.id == urlNav
            ) || null;
          }
        }

        // VERIFICAR SI ES PIZZA
        const evaluacion = ["Pizza", "Pizzas", "Pizza Clasica", "Pizza Premium", "Pizza Grande", "Pizza Familiar", "Mitad & Mitad"];
        this.esPizza = evaluacion.some(evaluacion => this.producto.colecciones.includes(evaluacion));
      }

      inicializarEventos() {
        // Event Listeners - Botones de cantidad
        if (this.btnsContenedorCantidad && this.btnsContenedorCantidad.length > 0) {
          this.btnsContenedorCantidad.forEach((btn) => {
            btn.addEventListener(
              "click",
              this.actualizarEstadoBotonesInferiores.bind(this)
            );
          });
        }

        // Event Listeners - Estados vacíos
        this.estadoVacioContenedorPostres.addEventListener(
          "click",
          this.verProductosEspeciales.bind(this, "postres", "")
        );
        this.estadoVacioContenedorGaseosas.addEventListener(
          "click",
          this.verProductosEspeciales.bind(this, "gaseosas", "")
        );

        // Event Listeners - Botones del modal
        this.btnSeccionModalSalir.addEventListener(
          "click",
          this.verProductosEspeciales.bind(this, "", "")
        );
        this.btnSeccionModalGuardar.addEventListener(
          "click",
          this.editarProductosComplementarios.bind(this)
        );

        // Event Listeners - Botones anadir más
        this.anadirMasContenedorPostres.addEventListener(
          "click",
          this.abrirSeccionModalExtras.bind(this, "postres", "")
        );
        this.anadirMasContenedorGaseosas.addEventListener(
          "click",
          this.abrirSeccionModalExtras.bind(this, "gaseosas", "")
        );

        this.btnVolverAtras = this.querySelector("#phpp-btn-volver-atras");
        this.btnVolverAtras.addEventListener("click", () => {
          if (window.history.length > 1) {
            window.history.back();
          } else {
            window.location.href = "/";
          }
        });

      }

      construccionSecciones() {
        // Restaurar desde carrito (phicse): mismo producto → preselección tamaño + opciones
        const vieneDelCarrito = typeof window !== 'undefined' && new URLSearchParams(window.location.search).get('from') === 'cart';
        const phicseRaw = localStorage.getItem('phicse');
        if (phicseRaw) {
          const detalleProducto = JSON.parse(phicseRaw);
          this.cantidadProductoGeneralEtiqueta.innerHTML = detalleProducto.item_base.cantidad;
          const mismoProducto =
            this.producto.handle == detalleProducto.item_base.idtrabajo &&
            this.producto.idshopify == detalleProducto.item_base.idshopify;

          if (mismoProducto && vieneDelCarrito) {
            // 1) Preseleccionar solo el tamaño (antes de estructurar)
            const prodTamano = detalleProducto?.items_principales?.productos?.find(
              (p) => p.titulo === "Tamaño"
            );
            if (prodTamano && this.producto?.metafield?.secciones) {
              const seccionTamano = this.producto.metafield.secciones.find(
                (s) => s.key === "tamano" || s.titulo === "Tamaño"
              );
              const tamañoEncontrado = seccionTamano?.productos?.find(
                (p) =>
                  p.titulo === prodTamano.nombre ||
                  String(p.id) === String(prodTamano.idtrabajo)
              );
              if (tamañoEncontrado) {
                this.sizeSeleccionado = tamañoEncontrado;
              }
            }
          }

          // 2) Estructurar construcción con el tamaño seleccionado
          this.seleccionCondimentos.estructurarContruccion(this.sizeSeleccionado);

          // 3) Preseleccionar el resto de opciones (condimentos, etc.)
          const productosCarrito = detalleProducto?.items_principales?.productos || [];
          productosCarrito.forEach((prodCarrito) => {
            if (prodCarrito.titulo === "Tamaño") return;

            const seccionEncontrada = this.seleccionCondimentos.seccionesConstruccion?.find(
              (s) => s.titulo === prodCarrito.titulo
            );
            if (seccionEncontrada) {
              const productoEncontrado = seccionEncontrada.productos?.find(
                (p) => p.titulo === prodCarrito.nombre
              );
              if (productoEncontrado && productoEncontrado.estado) {
                const keyCondimento = `${seccionEncontrada.key}-${productoEncontrado.id}-${productoEncontrado.titulo}`;
                this.seleccionCondimentos.opcionesSeleccionadas.set(
                  keyCondimento,
                  seccionEncontrada.key
                );
              }
            }
          });
        } else {
          this.seleccionCondimentos.estructurarContruccion(this.sizeSeleccionado);
        }

        if (this.producto.colecciones.includes("Mitad & Mitad")) {
          this._construccionSeccionesMitadYMitad();
        } else {
          this._construccionSeccionesNormales();
        }

        this._inicializarEventosCondimentos();

        // IMPORTANTE: Inicializar eventos de mitad y mitad DESPUÉS de todo
        if (this.producto.colecciones.includes("Mitad & Mitad")) {
          this._inicializarEventosMitadYMitad();
        }

        this.actualizarEstadoBotonesInferiores();
      }

      // Función auxiliar: Generar HTML de un condimento
      _generarHTMLCondimento(seccion, condimento) {
        const estadoHTML = this.seleccionCondimentos.estadoCondimentoConstruccion(
          seccion,
          condimento,
          this.sizeSeleccionado
        );

        const condimentoTrabajo = this.seleccionCondimentos.seccionesConstruccion
          .find(s => s.key === seccion.key)
          ?.productos.find(p => p.titulo === condimento.titulo);

        if (!condimentoTrabajo) return '';

        // Determinar si es Mitad & Mitad
        const esMitadYMitad = this.producto.colecciones.includes("Mitad & Mitad");

        // Determinar imagen auxiliar según si es Mitad & Mitad
        const imagenAuxiliar = esMitadYMitad
          ? window.assets.imagen_aux
          : window.assets.imagen_aux;

        // Usar imagen del condimento o imagen auxiliar correspondiente
        const imagenSrc = condimentoTrabajo.urlImage?.trim()
          ? condimentoTrabajo.urlImage
          : imagenAuxiliar;

        // Lógica de display:
        // - Si es Mitad & Mitad: SIEMPRE mostrar (flex)
        // - Si NO es Mitad & Mitad: mostrar solo si tiene urlImage
        const mostrarImagen = esMitadYMitad
          ? 'flex'
          : (condimentoTrabajo.urlImage ? 'flex' : 'none');

        return `
          <button 
            data-id="${condimentoTrabajo.id}"
            data-titulo="${condimentoTrabajo.titulo}" 
            id="condimento" 
            class="pmp-item-complejo ${estadoHTML}">
            <div class="pmp-item-complejo-imagen" style="display: ${mostrarImagen};">
              <img src="${imagenSrc}" alt="${condimentoTrabajo.titulo}" width="100%" height="100%">
            </div>
            <div class="pmp-item-complejo-info">
              <div class="pmp-item-complejo-info-detalle">
                <p>${condimentoTrabajo.titulo}</p>
                ${condimentoTrabajo.precio > 0 ? `<p id="pmp-item-info-precio">${condimentoTrabajo.precio} Bs</p>` : ''}
              </div>
              <div class="pmp-item-simple-escoger">
                ${estadoHTML === "seleccionado" ? window.shopIcons.icon_estado_on_plus : window.shopIcons.icon_estado_off}
              </div>
            </div>
          </button>
        `;
      }

      // Función auxiliar: Generar HTML de una sección
      _generarHTMLSeccion(seccion) {
        const condimentosHTML = seccion.productos
          .map(condimento => this._generarHTMLCondimento(seccion, condimento))
          .join('');

        return `
          <div  
            data-key="${seccion.key}"
            data-min="${seccion.min}"
            data-max="${seccion.max}"
            id="seccion-condimentos" 
            class="pmph-seleccion-normal">
            <h3>${seccion.titulo}</h3>
            ${condimentosHTML}
          </div>    
        `;
      }

      // Función auxiliar: Generar HTML de producto para mitad y mitad
      _generarHTMLProductoMitadYMitad(condimento) {
        // Validar stock y estado
        // if (!GestorProductos.obtenerStockYEstadoToppings(condimento.estado, condimento.sucursales)) {
        // return ''; // No renderizar si no hay stock o no está activo
        // }

        // Determinar imagen: usar urlImage o imagen auxiliar de mitad y mitad
        let imagenSrc = window.assets.imagen_aux_mitadYmitad1;
        if (condimento.urlImage?.trim()) {
          imagenSrc = condimento.urlImage;
        }

        return `
    <div 
      data-idtrabajo="${condimento.id}"
      data-titulo="${condimento.titulo}"
      class="producto-item">
      <div class="producto-item-imagen">
        <img src="${imagenSrc}" alt="${condimento.titulo}" width="100%" height="100%">
      </div>
      <div tipo-producto="simple" class="producto-item-detalle">
        <div class="producto-item-info">
          <h3>${condimento.titulo}</h3>
        </div>
        <h3 class="color-letras-primary">${condimento.precio} Bs</h3>
        <button id="phpm-btn-mitadYmitad-elegir" class="ph-btn-general">
          <p class="color-letras-secondary">ELEGIR</p>
        </button>
      </div>
    </div>
  `;
      }

      // Construcción para productos Mitad & Mitad
      _construccionSeccionesMitadYMitad() {
        let contenidoSeccionesHTML = '';
        let contenidoLadoIzquierdo = '';
        let contenidoLadoDerecho = '';

        this.producto.metafield.secciones.forEach((seccion) => {
          const tituloLower = seccion.titulo.toLowerCase();

          // Sección de masa-borde (común para ambos lados)
          if (seccion.key === "rama1" || tituloLower.includes("masa")) {
            contenidoSeccionesHTML += this._generarHTMLSeccion(seccion);
          }
          // Secciones de sabores por lado
          else if (tituloLower.includes("lado izquierdo") || seccion.key === "rama2") {
            // GUARDAR la sección para uso posterior
            this.productosLIMM = seccion;

            contenidoLadoIzquierdo = seccion.productos
              .map(producto => this._generarHTMLProductoMitadYMitad(producto))
              .join('');
          }
          else if (tituloLower.includes("lado derecho") || seccion.key === "rama3") {
            // GUARDAR la sección para uso posterior
            this.productosLDMM = seccion;

            contenidoLadoDerecho = seccion.productos
              .map(producto => this._generarHTMLProductoMitadYMitad(producto))
              .join('');
          }
        });

        // Insertar contenido en el DOM
        this.querySelector(".pmph-seleccion")?.insertAdjacentHTML("afterbegin", contenidoSeccionesHTML);

        // Asignar productos a los modales
        if (this.seccionModalExtrasLIMM) {
          this.seccionModalExtrasLIMM.innerHTML = contenidoLadoIzquierdo;
        }
        if (this.seccionModalExtrasLDMM) {
          this.seccionModalExtrasLDMM.innerHTML = contenidoLadoDerecho;
        }
      }

      // Construcción para productos normales
      _construccionSeccionesNormales() {
        const contenidoHTML = this.seleccionCondimentos.seccionesConstruccion
          .filter(seccion => seccion.tipo !== "subcarrito")
          .map(seccion => this._generarHTMLSeccion(seccion))
          .join('');

        this.querySelector(".pmph-seleccion")?.insertAdjacentHTML("afterbegin", contenidoHTML);
      }

      // Inicializar eventos de condimentos
      _inicializarEventosCondimentos() {
        this.condimentosHTML = this.querySelectorAll("#condimento");
        this.condimentosHTML.forEach((condimentoHTML) => {
          condimentoHTML.addEventListener("click", () => {
            this.eventoSeleccionCondimento(condimentoHTML);
          });
        });
      }

      // Inicializar eventos específicos de mitad y mitad
      _inicializarEventosMitadYMitad() {
        // Botones de elegir lado
        this.btnsElegirLadoMitadYMitad = this.querySelectorAll("#phpm-btn-mitadYmitad-elegir");
        this.btnsElegirLadoMitadYMitad.forEach((btnElemento) => {
          btnElemento.addEventListener("click", () => this.procesoElegirLadoMitadYMitad(btnElemento));
        });

        // Botones principales del modal (LIMM y LDMM)
        if (this.btnModalLIMM) {
          this.btnModalLIMM.addEventListener("click", () =>
            this.verProductosEspeciales("mitadymitad", "LIMM")
          );
        }
        if (this.btnModalLDMM) {
          this.btnModalLDMM.addEventListener("click", () =>
            this.verProductosEspeciales("mitadymitad", "LDMM")
          );
        }

        // Botones de imágenes para ver productos
        if (this.imagenProductoBtnLIMM) {
          this.imagenProductoBtnLIMM.addEventListener("click", () =>
            this.verProductosEspeciales("mitadymitad", "LIMM")
          );
        }
        if (this.imagenProductoBtnLDMM) {
          this.imagenProductoBtnLDMM.addEventListener("click", () =>
            this.verProductosEspeciales("mitadymitad", "LDMM")
          );
        }
      }

      eventoSeleccionCondimento(condimentoHTML) {
        // Obtener datos del condimento
        const seccionHTML = condimentoHTML.closest("#seccion-condimentos");
        const seccionKey = seccionHTML.dataset.key;
        const seccion = this.seleccionCondimentos.seccionesConstruccion.find(s => s.key === seccionKey);
        const condimentoSeleccionado = seccion?.productos.find(
          p => p.titulo === condimentoHTML.dataset.titulo
        );
        const estaSeleccionado = condimentoHTML.classList.contains("seleccionado");

        // SECCIÓN DE Tamano
        if (seccionKey === "tamano" && this.producto.colecciones.some(coleccion => coleccion.includes("Pizza"))) {
          if (estaSeleccionado) {
            // DESELECCIONAR Tamano
            const resultado = this.seleccionCondimentos.intentarDeseleccionar(condimentoSeleccionado, seccionKey);

            if (resultado.permitido) {
              this._marcarDeseleccionado(condimentoHTML);
            }
            // Si no está permitido, la lógica ya revirtió el cambio en el Map

          } else {
            // SELECCIONAR nuevo Tamano
            this.sizeSeleccionado = this.seleccionCondimentos.secciones
              .find(s => s.key === "tamano")
              ?.productos.find(p => p.id === condimentoHTML.dataset.id);

            const { tamanoAnterior } = this.seleccionCondimentos.cambiarTamano(
              condimentoSeleccionado,
              seccionKey
            );

            // Marcar nuevo Tamano seleccionado
            this._marcarSeleccionado(condimentoHTML);

            // Deseleccionar Tamano anterior en HTML
            if (tamanoAnterior) {
              const [_, __, tituloAnterior] = tamanoAnterior.split('-');
              const tamanoAnteriorHTML = this._buscarCondimentoHTMLPorTitulo(seccionHTML, tituloAnterior);

              if (tamanoAnteriorHTML && tamanoAnteriorHTML !== condimentoHTML) {
                this._marcarDeseleccionado(tamanoAnteriorHTML);
              }
            }

            // Actualizar todas las demás secciones
            this.seleccionCondimentos.seccionesConstruccion.forEach(seccion => {
              if (seccion.key === "tamano" || seccion.tipo === "subcarrito") return;

              console.log(`\n🔍 === Actualizando HTML de sección "${seccion.key}" ===`);

              const seccionHTML = this.querySelector(`[data-key="${seccion.key}"]`);
              if (!seccionHTML) {
                console.log(`❌ No se encontró el HTML de la sección`);
                return;
              }

              const condimentosHTML = seccionHTML.querySelectorAll("#condimento");
              console.log(`📋 Total de condimentos HTML encontrados: ${condimentosHTML.length}`);

              condimentosHTML.forEach(condHTML => {
                const condimento = seccion.productos?.find(p => p.titulo === condHTML.dataset.titulo);
                if (!condimento) {
                  console.log(`  ⚠️  No se encontró condimento para HTML: ${condHTML.dataset.titulo}`);
                  return;
                }

                const estaSeleccionadoHTML = condHTML.classList.contains("seleccionado");
                console.log(`  🔸 Procesando "${condimento.titulo}": seleccionadoHTML=${estaSeleccionadoHTML}`);

                // Llamar a la lógica para procesar el condimento
                const resultado = this.seleccionCondimentos.procesarCondimentoCambioDeTamano(
                  condimento,
                  seccion,
                  estaSeleccionadoHTML,
                  this.sizeSeleccionado
                );

                console.log(`    → Acción: ${resultado.accion}, EstadoCalculado: ${resultado.estadoCalculado}`);

                // Aplicar cambios en HTML según el resultado
                if (resultado.accion === 'reemplazar') {
                  this._marcarDeseleccionado(condHTML);
                  console.log(`    ✓ Deseleccionado en HTML`);

                  if (resultado.condimentoSiguiente) {
                    const siguienteHTML = this._buscarCondimentoHTMLPorTitulo(
                      seccionHTML,
                      resultado.condimentoSiguiente.titulo
                    );
                    if (siguienteHTML) {
                      this._marcarSeleccionado(siguienteHTML);
                      console.log(`    ✓ Siguiente seleccionado: ${resultado.condimentoSiguiente.titulo}`);
                    } else {
                      console.log(`    ❌ No se encontró HTML para siguiente: ${resultado.condimentoSiguiente.titulo}`);
                    }
                  }
                } else if (resultado.accion === 'sincronizar_agregar') {
                  this._marcarSeleccionado(condHTML);
                  console.log(`    ✓ Sincronizado (agregado) en HTML`);
                } else if (resultado.accion === 'sincronizar_eliminar') {
                  this._marcarDeseleccionado(condHTML);
                  console.log(`    ✓ Sincronizado (eliminado) en HTML`);
                }

                // Actualizar precio y clase desactivado
                this._actualizarPrecio(condHTML, condimento);
                this._actualizarClaseDesactivado(condHTML, resultado.estadoCalculado);
              });

              // 🔴 NUEVO: Verificar si hay condimentos en el Map que NO están en el HTML
              console.log(`\n🔍 Verificando condimentos en Map que no están reflejados en HTML...`);
              this.seleccionCondimentos.opcionesSeleccionadas.forEach((value, key) => {
                if (value !== seccion.key) return;

                const sinPrefijo = key.substring(value.length + 1);
                const primerGuion = sinPrefijo.indexOf('-');
                const titulo = sinPrefijo.substring(primerGuion + 1);

                const htmlExiste = Array.from(condimentosHTML).some(cHTML =>
                  cHTML.dataset.titulo === titulo && cHTML.classList.contains("seleccionado")
                );

                if (!htmlExiste) {
                  console.log(`  ⚠️  "${titulo}" está en Map pero NO seleccionado en HTML`);

                  // Buscar y seleccionar en HTML
                  const condHTML = this._buscarCondimentoHTMLPorTitulo(seccionHTML, titulo);
                  if (condHTML) {
                    this._marcarSeleccionado(condHTML);
                    console.log(`    ✅ Ahora seleccionado en HTML`);
                  } else {
                    console.log(`    ❌ No se encontró el elemento HTML`);
                  }
                }
              });

              console.log(`✅ === Fin actualización sección "${seccion.key}" ===\n`);
            });
          }
        }
        // OTRAS SECCIONES (ingredientes, extras, etc.)
        else {
          if (estaSeleccionado) {
            // DESELECCIONAR condimento
            const resultado = this.seleccionCondimentos.intentarDeseleccionar(condimentoSeleccionado, seccionKey);

            if (resultado.permitido) {
              this._marcarDeseleccionado(condimentoHTML);
            }
            // Si no está permitido, la lógica ya revirtió el cambio

          } else {
            // SELECCIONAR condimento
            const resultado = this.seleccionCondimentos.intentarSeleccionar(condimentoSeleccionado, seccionKey);

            // Marcar nuevo condimento seleccionado
            this._marcarSeleccionado(condimentoHTML);

            // Si necesita reemplazar, deseleccionar el anterior
            if (resultado.accion === 'reemplazar' && resultado.condimentoAReemplazar) {
              const [_, __, tituloAnterior] = resultado.condimentoAReemplazar.split('-');
              const condimentoAnteriorHTML = Array.from(seccionHTML.querySelectorAll("#condimento"))
                .find(c => c.dataset.titulo === tituloAnterior);

              if (condimentoAnteriorHTML) {
                this._marcarDeseleccionado(condimentoAnteriorHTML);
              }
            }
          }
        }

        this.actualizarEstadoBotonesInferiores();
      }

      _marcarSeleccionado(condimentoHTML) {
        condimentoHTML.classList.add("seleccionado");
        condimentoHTML.querySelector(".pmp-item-simple-escoger").innerHTML = window.shopIcons.icon_estado_on_plus;
      }

      _marcarDeseleccionado(condimentoHTML) {
        condimentoHTML.classList.remove("seleccionado");
        condimentoHTML.querySelector(".pmp-item-simple-escoger").innerHTML = window.shopIcons.icon_estado_off;
      }

      _actualizarPrecio(condimentoHTML, condimento) {
        const precioElement = condimentoHTML.querySelector("#pmp-item-info-precio");
        if (precioElement) {
          precioElement.innerHTML = condimento.precio == 0 ? "" : `${condimento.precio} Bs`;
        }
      }

      _actualizarClaseDesactivado(condimentoHTML, estadoCalculado) {
        if (estadoCalculado === "desactivado") {
          condimentoHTML.classList.add("desactivado");
        } else if (condimentoHTML.classList.contains("desactivado")) {
          condimentoHTML.classList.remove("desactivado");
        }
      }

      _buscarCondimentoHTMLPorTitulo(seccionHTML, titulo) {
        return seccionHTML.querySelector(`#condimento[data-titulo="${titulo}"]`);
      }

      // Actualiza el estado de los botones inferiores basado en las selecciones del usuario.
      // Se ejecuta al completar la construcción del producto o al seleccionar elementos
      // en ramas principales, extras de postres y gaseosas.
      async actualizarEstadoBotonesInferiores() {
        // Inicializar variables de precios
        var precioTotalCondimentos = 0;
        var precioComparacionTotalCondimentos = 0;
        var cantidadPrecioTotalExtras = 0;

        const cantidad = parseInt(this.querySelector("#phpd-cantidad-general").innerHTML);

        if (!this.esPizza) {
          precioTotalCondimentos = this.producto.precio * cantidad;
          precioComparacionTotalCondimentos = this.producto.precio_comparacion * cantidad;
        }

        // ==================== PROCESAMIENTO CONDIMENTOS ====================
        this.seleccionCondimentos.opcionesSeleccionadas.forEach((value, key) => {
          const seccionKey = value;  // El value YA contiene el seccionKey

          // Remover el prefijo "seccionKey-" para obtener "id-titulo"
          const sinPrefijo = key.substring(seccionKey.length + 1);

          // Encontrar el primer guión para separar id de titulo
          const primerGuion = sinPrefijo.indexOf('-');
          const id = sinPrefijo.substring(0, primerGuion);
          const titulo = sinPrefijo.substring(primerGuion + 1);  // Esto preserva guiones en el título

          const seccion = this.seleccionCondimentos.seccionesConstruccion.find(s => s.key === seccionKey);
          const producto = seccion?.productos.find(p => p.id === id && p.titulo === titulo);

          if (!producto) {
            console.warn(`Producto no encontrado: ${key}`);
            return;
          }

          // Sumar precio normal
          precioTotalCondimentos += producto.precio * cantidad;

          // Sumar precio de comparación
          const precioComparacion = (producto.precio_comparacion && producto.precio_comparacion > 0)
            ? producto.precio_comparacion
            : producto.precio;
          precioComparacionTotalCondimentos += precioComparacion * cantidad;
        });

        // ==================== PROCESAMIENTO EXTRAS - POSTRES ====================
        if (this.estadoItemsContenedorPostres) {
          this.estadoItemsContenedorPostres
            .querySelectorAll("#pmp-item-extra")
            .forEach((itemHTML) => {
              const precio = parseInt(itemHTML.dataset.precio);
              const cantidad = parseInt(itemHTML.dataset.cantidad);
              cantidadPrecioTotalExtras += precio * cantidad;
            });
        }

        // ==================== PROCESAMIENTO EXTRAS - GASEOSAS ====================
        if (this.estadoItemsContenedorGaseosas) {
          this.estadoItemsContenedorGaseosas
            .querySelectorAll("#pmp-item-extra")
            .forEach((itemHTML) => {
              const precio = parseInt(itemHTML.dataset.precio);
              const cantidad = parseInt(itemHTML.dataset.cantidad);
              cantidadPrecioTotalExtras += precio * cantidad;
            });
        }

        // ==================== PROCESAMIENTO MITAD Y MITAD (IZQUIERDA Y DERECHA) ====================
        if (this.producto.colecciones.includes("Mitad & Mitad")) {
          if (this.infoPizzaLDMM !== null) {
            cantidadPrecioTotalExtras += this.infoPizzaLDMM.precio * cantidad;
          }

          if (this.infoPizzaLIMM !== null) {
            cantidadPrecioTotalExtras += this.infoPizzaLIMM.precio * cantidad;
          }
        }

        // ==================== CÁLCULOS FINALES Y ACTUALIZACIÓN UI ====================

        // Asignar el precio total (condimentos + extras)
        this.precioTotalCondimentos = precioTotalCondimentos;
        this.precioTotalExtras = cantidadPrecioTotalExtras
        this.precio = precioTotalCondimentos + cantidadPrecioTotalExtras;
        this.precio_comparacion = precioComparacionTotalCondimentos + cantidadPrecioTotalExtras;

        // Actualizar etiquetas HTML
        this.etiquetaAgregarCarrito.innerHTML =
          this.precio > 0
            ? `${this.precio} Bs`
            : "";

        // IMPORTANTE: Solo mostrar precio de comparación si es MAYOR al precio normal
        // Si son iguales, significa que no hay descuento y no debe mostrarse
        this.etiquetaACPrecioComparacion.innerHTML =
          (this.precio_comparacion > 0 && this.precio_comparacion > this.precio)
            ? `${this.precio_comparacion} Bs`
            : "";
      }

      async procesoBotonesInferiores(tipoProceso) {
        MensajeCargaDatos.mostrar("Agregando al carrito ...");
        // Recorrer todo y generar un objeto para introducir al carrito
        this.carritoShopify = await AuxiliaresGlobal.obtenerCarritoShopify();
        console.log("Carrito Shopify: ", this.carritoShopify);
        const cantidad = parseInt(this.querySelector("#phpd-cantidad-general").innerHTML);
        var productosOpciones = [];
        var productosComple = [];

        if (this.producto.colecciones.includes("Mitad & Mitad")) {
          // Verificar si falta algún sabor
          if (this.infoPizzaLDMM == null || this.infoPizzaLIMM == null) {
            let mensaje = "";

            if (this.infoPizzaLDMM == null && this.infoPizzaLIMM == null) {
              mensaje =
                "Por favor, seleccione los sabores para ambos lados de su pizza.";
            } else if (this.infoPizzaLDMM == null) {
              mensaje =
                "Por favor, seleccione el sabor para el lado derecho de su pizza.";
            } else {
              mensaje =
                "Por favor, seleccione el sabor para el lado izquierdo de su pizza.";
            }

            MensajeCargaDatos.ocultar();
            MensajeTemporal.mostrarMensaje(mensaje, "alerta", 3500);
            return;
          }

          // Si llegamos aquí, ambos sabores están seleccionados

          productosOpciones.push(
            new ItemCarrito({
              idshopify: this.infoPizzaLDMM.id,
              idtrabajo: this.infoPizzaLDMM.id,
              titulo: "SABOR LADO DERECHO",
              nombre: this.infoPizzaLDMM.titulo,
              precio: this.infoPizzaLDMM.precio,
              precio_comparacion: this.infoPizzaLDMM.precio_comparacion,
              cantidad: cantidad,
            })
          );

          productosOpciones.push(
            new ItemCarrito({
              idshopify: this.infoPizzaLIMM.id,
              idtrabajo: this.infoPizzaLIMM.id,
              titulo: "SABOR LADO IZQUIERDO",
              nombre: this.infoPizzaLIMM.titulo,
              precio: this.infoPizzaLIMM.precio,
              precio_comparacion: this.infoPizzaLIMM.precio_comparacion,
              cantidad: cantidad,
            })
          );
        }

        this.seleccionCondimentos.opcionesSeleccionadas.forEach((value, key) => {
          const seccionKey = value;

          // Remover el prefijo "seccionKey-" para obtener "id-titulo"
          const sinPrefijo = key.substring(seccionKey.length + 1);

          // Encontrar el primer guión para separar id de titulo
          const primerGuion = sinPrefijo.indexOf('-');
          const id = sinPrefijo.substring(0, primerGuion);
          const titulo = sinPrefijo.substring(primerGuion + 1);

          const seccion = this.seleccionCondimentos.seccionesConstruccion.find(s => s.key === seccionKey);
          const producto = seccion?.productos.find(p => p.id === id && p.titulo === titulo);

          if (!producto) {
            console.warn(`Producto no encontrado al agregar al carrito: ${key}`);
            return;
          }

          console.log(producto);
          productosOpciones.push(
            new ItemCarrito({
              idshopify: producto.id,
              idtrabajo: producto.id,
              titulo: seccion.titulo,
              nombre: producto.titulo,
              precio: producto.precio,
              precio_comparacion: producto.precio_comparacion,
              cantidad: cantidad,
            })
          );
        });

        this.estadoItemsContenedorPostres
          .querySelectorAll("#pmp-item-extra")
          .forEach((itemHTML) => {
            const idShopify = itemHTML.getAttribute("data-idshopify");
            const idTrabajo = itemHTML.getAttribute("data-idtrabajo");
            const titulo = itemHTML.getAttribute("data-titulo");
            const precio = itemHTML.getAttribute("data-precio");
            const precioComparacion = itemHTML.getAttribute(
              "data-precio-comparacion"
            );
            const imagenBase = itemHTML
              .querySelector(".pmp-item-extra-imagen img")
              .getAttribute("src");

            // Transformar URL relativa a URL completa
            const imagen = (() => {
              const regex = /\/cdn\/shop\/files\/([^?]+)\?.*v=(\d+)/;
              const match = imagenBase.match(regex);

              if (match) {
                const nombreArchivo = match[1];
                const version = match[2];
                return `https://cdn.shopify.com/s/files/1/0716/8622/6099/files/${nombreArchivo}?v=${version}`;
              }
              return imagenBase; // Si no coincide, devolver la original
            })();

            const coleccion = itemHTML.getAttribute("data-coleccion");
            const cantidad = itemHTML.getAttribute("data-cantidad");

            const productoEncontrado = this.productosComplementarios
              .find(
                (coleccionTrabajo) =>
                  coleccionTrabajo.nombre.toLowerCase() ==
                  coleccion.toLowerCase()
              )
              .productos.find((producto) => producto.idshopify == idShopify);

            productosComple.push(
              new ProductoCarrito({
                item_base: new ItemCarrito({
                  idshopify: idShopify,
                  idtrabajo: idTrabajo,
                  nombre: titulo,
                  precio: parseInt(precio),
                  precio_comparacion: parseInt(precioComparacion),
                  cantidad: cantidad,
                  imagen: imagen,
                  sucursales: productoEncontrado.sucursales,
                  stockTotal: productoEncontrado.stockTotal,
                }),
                items_principales: {
                  titulo: "Opciones Principales",
                  productos: [],
                },
                colecciones_trabajo: [coleccion],
              })
            );
          });

        this.estadoItemsContenedorGaseosas
          .querySelectorAll("#pmp-item-extra")
          .forEach((itemHTML) => {
            const idShopify = itemHTML.getAttribute("data-idshopify");
            const idTrabajo = itemHTML.getAttribute("data-idtrabajo");
            const titulo = itemHTML.getAttribute("data-titulo");
            const precio = itemHTML.getAttribute("data-precio");
            const precioComparacion = itemHTML.getAttribute(
              "data-precio-comparacion"
            );
            const imagenBase = itemHTML
              .querySelector(".pmp-item-extra-imagen img")
              .getAttribute("src");

            // Transformar URL relativa a URL completa
            const imagen = (() => {
              const regex = /\/cdn\/shop\/files\/([^?]+)\?.*v=(\d+)/;
              const match = imagenBase.match(regex);

              if (match) {
                const nombreArchivo = match[1];
                const version = match[2];
                return `https://cdn.shopify.com/s/files/1/0716/8622/6099/files/${nombreArchivo}?v=${version}`;
              }

              return imagenBase; // Si no coincide, devolver la original
            })();

            const coleccion = itemHTML.getAttribute("data-coleccion");
            const cantidad = itemHTML.getAttribute("data-cantidad");

            const productoEncontrado = this.productosComplementarios
              .find(
                (coleccionTrabajo) =>
                  coleccionTrabajo.nombre.toLowerCase() ==
                  coleccion.toLowerCase()
              )
              .productos.find((producto) => producto.idshopify == idShopify);

            productosComple.push(
              new ProductoCarrito({
                item_base: new ItemCarrito({
                  idshopify: idShopify,
                  idtrabajo: idTrabajo,
                  nombre: titulo,
                  precio: parseInt(precio),
                  cantidad: cantidad,
                  imagen: imagen,
                  precio_comparacion: parseInt(precioComparacion),
                  sucursales: productoEncontrado.sucursales,
                  stockTotal: productoEncontrado.stockTotal,
                  tipoProducto: "basico",
                }),
                items_principales: {
                  titulo: "Opciones Principales",
                  productos: [],
                },
                colecciones_trabajo: [coleccion],
              })
            );
          });

        // Agregar al carrito de Shopifyy
        // precito total conjunto = (precioBase * cantidad) + (precio "opciones principales") + (precio "complementos")
        // precio producto : este precio es respecto sin nada de variantes ni adicionales es base
        // el precio total del producto opciones es recorriendo todos los elementos seleccionados que estan dentro
        // el precio total del producto complementos es recorriendo todos los elementos seleccionados que estan dentro

        const productoCarrito = new ProductoCarrito({
          item_base: new ItemCarrito({
            idshopify: this.producto.idshopify,
            idtrabajo: this.producto.idtrabajo,
            nombre: this.producto.nombre,
            precio: this.esPizza ? 0 : this.producto.precio,
            precio_comparacion: this.esPizza ? 0 : this.producto.precio_comparacion,
            cantidad: cantidad,
            imagen: this.producto.imagen,
            sucursales: this.producto.sucursales,
            stockTotal: this.producto.stockTotal,
            obj_num: this.producto.obj_num,
          }),
          items_principales: {
            titulo: "Opciones Principales",
            productos: productosOpciones,
          },
          colecciones_trabajo: this.producto.colecciones,
        });

        const unificacionProductosTrabajo = [
          productoCarrito,
          ...productosComple,
        ];


        if (tipoProceso == "agregarcarrito") {
          var productosCoincidentes = [];

          // Si vino desde "editar" en carrito: eliminar ítem viejo y tratar como nuevo
          const fromCart = new URLSearchParams(window.location.search).get('from') === 'cart';
          const phicseRaw = localStorage.getItem('phicse');
          if (fromCart && phicseRaw) {
            try {
              const phicse = JSON.parse(phicseRaw);
              if (phicse && phicse.key) {
                await AuxiliaresGlobal.eliminarItemCarritoPorKey(phicse.key, 0);
                this.carritoShopify = await AuxiliaresGlobal.obtenerCarritoShopify();
                localStorage.removeItem('phicse');
              }
            } catch (e) { console.warn('phicse parse:', e); }
          }


          // ============================================================
          // CASO 1: CARRITO VACÍO
          // ============================================================
          // Si el carrito está completamente vacío, agregar directamente
          if (this.carritoShopify.informacionCompleta.items.length == 0) {
            await AuxiliaresGlobal.agregarMultiplesProductosCarrito([
              ...unificacionProductosTrabajo.map((producto) => {
                return {
                  varianteId: parseInt(producto.item_base.idshopify),
                  cantidad: parseInt(producto.item_base.cantidad),
                  properties: { estructura: JSON.stringify(producto) },
                };
              }),
            ]);
          }
          // ============================================================
          // CASO 2: CARRITO CON ITEMS
          // ============================================================
          // Buscar si ya existe un producto igual para solo aumentar cantidad
          else {
            // 2.1 - Comparar cada item del carrito con CADA producto que se quiere agregar
            unificacionProductosTrabajo.forEach((productoNuevo) => {
              const itemCoincidente = this.carritoShopify.informacionCompleta.items.find((item) => {
                if (!item.properties?.estructura) return false;

                try {
                  const info = JSON.parse(item.properties.estructura);
                  if (!info || !info.item_base) return false;

                  // Verificar que el producto base coincida
                  if (
                    productoNuevo.item_base.idshopify != info.item_base.idshopify ||
                    productoNuevo.item_base.idtrabajo != info.item_base.idtrabajo
                  ) {
                    return false;
                  }

                  // Verificar que las opciones principales sean exactamente las mismas
                  const opInfo = info.items_principales.productos || [];
                  const opNuevo = productoNuevo.items_principales.productos || [];

                  // Deben tener la misma cantidad de opciones
                  if (opInfo.length !== opNuevo.length) return false;

                  // Verificar que cada opción coincida (solo por ID)
                  const opcionesOK = opInfo.every((p1) =>
                    opNuevo.some(
                      (p2) =>
                        p1.idshopify == p2.idshopify &&
                        p1.idtrabajo == p2.idtrabajo
                    )
                  );

                  return opcionesOK;
                } catch (error) {
                  console.error("Error al analizar JSON:", error);
                  return false;
                }
              });

              // Guardar la coincidencia junto con el producto nuevo
              if (itemCoincidente) {
                productosCoincidentes.push({
                  itemCarrito: itemCoincidente,
                  productoNuevo: productoNuevo
                });
              }
            });

            // 2.2 - Separar productos que coinciden y los que no
            const productosNuevos = unificacionProductosTrabajo.filter((productoNuevo) => {
              return !productosCoincidentes.some(
                (coincidencia) => coincidencia.productoNuevo === productoNuevo
              );
            });

            // 2.3 - Agregar productos completamente nuevos (sin coincidencias)
            if (productosNuevos.length > 0) {
              await AuxiliaresGlobal.agregarMultiplesProductosCarrito([
                ...productosNuevos.map((producto) => {
                  return {
                    varianteId: parseInt(producto.item_base.idshopify),
                    cantidad: parseInt(producto.item_base.cantidad),
                    properties: { estructura: JSON.stringify(producto) },
                  };
                }),
              ]);
            }

            // 2.4 - Actualizar cantidad de productos coincidentes
            if (productosCoincidentes.length > 0) {
              // Eliminar los productos coincidentes del carrito
              const keysAEliminar = productosCoincidentes.map(
                (coincidencia) => coincidencia.itemCarrito.key
              );
              await AuxiliaresGlobal.eliminarMultiplesProductos(keysAEliminar);

              // Sumar las cantidades del carrito + las nuevas cantidades
              const productosActualizados = productosCoincidentes.map((coincidencia) => {
                const infoCarrito = JSON.parse(
                  coincidencia.itemCarrito.properties.estructura
                );
                const productoNuevo = coincidencia.productoNuevo;

                // Sumar cantidad del item_base
                productoNuevo.item_base.cantidad = `${parseInt(infoCarrito.item_base.cantidad) +
                  parseInt(productoNuevo.item_base.cantidad)
                  }`;

                // Sumar cantidades de las opciones principales
                productoNuevo.items_principales.productos.forEach((producto, index) => {
                  const cantidadCarrito =
                    infoCarrito.items_principales.productos[index]?.cantidad || 0;
                  producto.cantidad = `${parseInt(cantidadCarrito) + parseInt(producto.cantidad)
                    }`;
                });

                return productoNuevo;
              });

              // Agregar los productos con las cantidades actualizadas
              await AuxiliaresGlobal.agregarMultiplesProductosCarrito([
                ...productosActualizados.map((producto) => {
                  return {
                    varianteId: parseInt(producto.item_base.idshopify),
                    cantidad: parseInt(producto.item_base.cantidad),
                    properties: { estructura: JSON.stringify(producto) },
                  };
                }),
              ]);
            }
          }

          // ============================================================
          // FINALIZAR: Redirigir después de agregar al carrito
          // ============================================================
          setTimeout(async () => {
            this.elCarritoFueActualizado = false;
            await this.actualizarEstadoBotonesInferiores();
            MensajeCargaDatos.ocultar();
            if (document.referrer.includes("/pages/_menu-1")) {
              window.history.back();
            } else {
              window.location.replace("/pages/_menu-1?coleccion=Pizzas");
            }
          }, 2000);
        }
      }

      abrirSeccionModalExtras(tipoProductos) {
        if (tipoProductos == "postres") {
          this.seccionModalExtrasPostres.style.display = "flex";
          this.seccionModalExtrasGaseosas.style.display = "none";
          this.modalProductoExtras.style.display = "flex";
          this.cualSeccionExtrasEs = "postres";
        }
        if (tipoProductos == "gaseosas") {
          this.seccionModalExtrasPostres.style.display = "none";
          this.seccionModalExtrasGaseosas.style.display = "flex";
          this.modalProductoExtras.style.display = "flex";
          this.cualSeccionExtrasEs = "gaseosas";
        }
      }

      async eliminarItemExtras(btnElemento) {
        const tipoExtra = btnElemento.getAttribute("data-extras");

        if (tipoExtra == "postres") {
          const contenedorPadre = btnElemento.closest("#pmp-item-extra");
          const idTrabajo = contenedorPadre.getAttribute("data-idtrabajo");
          const idShopify = contenedorPadre.getAttribute("data-idshopify");

          this.itemsSeleccionadoPostres = this.itemsSeleccionadoPostres.filter(
            (item) => item.idTrabajo != idTrabajo && item.idShopify != idShopify
          );
          contenedorPadre.remove();

          // Buscar el elemento en id="phpp-modal-productos-postres" y Eliminarlo o limpiar la cantidad
          // this.seccionModalExtrasPostres = this.querySelector('#phpp-modal-productos-postres');
          const productosModal = this.seccionModalExtrasPostres
            .querySelector(".ppme-modal-items-extras")
            .querySelectorAll(".ppme-modal-item-extra");
          productosModal.forEach((itemHTML) => {
            const idTrabajoItem = itemHTML.getAttribute("data-idtrabajo");
            const idShopifyItem = itemHTML.getAttribute("data-idshopify");
            if (idShopifyItem == idShopify) {
              itemHTML.querySelector("#phpd-cantidad-extras").innerHTML = 0;
            }
          });

          // Proceder a contar la cantidad de elementos seleccionados en id="phpm-extras-especiales-postres"
          // this.estadoItemsContenedorPostres = this.querySelector('#phpm-extras-especiales-postres');
          const cantidadElementosSeleccionados =
            this.estadoItemsContenedorPostres.querySelectorAll(
              "#pmp-item-extra"
            ).length;

          // Si la cantidad es 0 mostrar contenedor vacio y ocultar el btn anadir
          if (cantidadElementosSeleccionados == 0) {
            this.estadoItemsContenedorPostres.style.display = "none";
            this.anadirMasContenedorPostres.style.display = "none";
            this.estadoVacioContenedorPostres.style.display = "flex";
          }
        }

        if (tipoExtra == "gaseosas") {
          const contenedorPadre = btnElemento.closest("#pmp-item-extra");
          const idTrabajo = contenedorPadre.getAttribute("data-idtrabajo");
          const idShopify = contenedorPadre.getAttribute("data-idshopify");

          this.itemsSeleccionadoGaseosas =
            this.itemsSeleccionadoGaseosas.filter(
              (item) =>
                item.idTrabajo != idTrabajo && item.idShopify != idShopify
            );
          contenedorPadre.remove();

          // Buscar el elemento en id="phpp-modal-productos-gaseosas" y Eliminarlo o limpiar la cantidad
          // this.seccionModalExtrasGaseosas = this.querySelector('#phpp-modal-productos-gaseosas');
          const productosModal = this.seccionModalExtrasGaseosas
            .querySelector(".ppme-modal-items-extras")
            .querySelectorAll(".ppme-modal-item-extra");
          productosModal.forEach((itemHTML) => {
            const idTrabajoItem = itemHTML.getAttribute("data-idtrabajo");
            const idShopifyItem = itemHTML.getAttribute("data-idshopify");
            if (idShopifyItem == idShopify) {
              itemHTML.querySelector("#phpd-cantidad-extras").innerHTML = 0;
            }
          });

          // Proceder a contar la cantidad de elementos seleccionados en id="phpm-extras-especiales-gaseosas"
          const cantidadElementosSeleccionados =
            this.estadoItemsContenedorGaseosas.querySelectorAll(
              "#pmp-item-extra"
            ).length;

          // Si la cantidad es 0 mostrar contenedor vacio y ocultar el btn anadir
          if (cantidadElementosSeleccionados == 0) {
            this.estadoItemsContenedorGaseosas.style.display = "none";
            this.anadirMasContenedorGaseosas.style.display = "none";
            this.estadoVacioContenedorGaseosas.style.display = "flex";
          }
        }

        await this.actualizarEstadoBotonesInferiores();
      }

      obtenerStockGenericoTrabajo(productoTrabajo) {
        // Verificar si tenemos una sucursal seleccionada
        if (!this.sucursal || this.sucursal == "")
          return productoTrabajo.stockTotal;

        const sucursalEncontrada = productoTrabajo.sucursales.find(
          (sucursal) => sucursal.nombre == this.sucursal.nombre
        );

        return sucursalEncontrada
          ? parseInt(sucursalEncontrada.stock)
          : productoTrabajo.stockTotal;
      }

      optenerStockTrabajo() {
        // Verificar si tenemos una sucursal seleccionada
        // Información del producto
        const dataTrabajo = JSON.parse(
          localStorage.getItem("phpp-productoData")
        );
        if (!this.sucursal || this.sucursal == "")
          return dataTrabajo.producto.stockTotal;

        const sucursalEncontrada = dataTrabajo.producto.sucursales.find(
          (sucursal) => sucursal.nombre == this.sucursal.nombre
        );

        return sucursalEncontrada
          ? parseInt(sucursalEncontrada.stock)
          : dataTrabajo.producto.stockTotal;
      }

      contenidoSiTienePrecio(nombre, precio) {
        if (parseInt(precio) > 0) {
          return `
          <h3>${nombre}</h3>
          <p>${precio} Bs</p>
          `;
        } else {
          return `
          <h3>${nombre}</h3>
          `;
        }
      }

      // CRUD : SELECCIONADOR (POSTRES - GASEOSAS)
      async creacionProductosComplementarios(sectorTrabajo) {
        let productos = null;
        let productosHTML = null;

        if (sectorTrabajo == "Postres") {
          productos = await GestorProductos.getProductosDeColeccionesEspecificas(["Postres"]);
          productosHTML = this.seccionModalExtrasPostres.querySelectorAll(".ppme-modal-item-extra");
        } else {
          productos = await GestorProductos.getProductosDeColeccionesEspecificas(["Gaseosas"]);
          productosHTML = this.seccionModalExtrasGaseosas.querySelectorAll(".ppme-modal-item-extra");
        }

        this.productosComplementarios = [
          ...(this.productosComplementarios || []),
          ...productos,
        ];

        if (productosHTML.length > 0) {
          productosHTML.forEach((elementoHTML) => {
            const idShopify = elementoHTML.getAttribute("data-idshopify");
            const productoInfoCompleta = this.productosComplementarios
              .find((coleccion) => coleccion.nombre == sectorTrabajo)
              ?.productos.find((producto) => idShopify == producto.idshopify);

            if (!productoInfoCompleta) {
              elementoHTML.style.display = "none";
              return;
            }

            // Filtrar igual que catalogo-producto-v1.js
            let stockTrabajo = productoInfoCompleta.stockTotal;
            let mostrarProducto = true;

            if (this.sucursal) {
              const sucursalEnShopify = window.sucursales.find(
                (s) => s.nombre == this.sucursal.nombre
              );

              if (!sucursalEnShopify?.estado) {
                mostrarProducto = false;
              } else {
                const sucursalProducto = productoInfoCompleta.sucursales.find(
                  (s) => s.nombre == this.sucursal.nombre
                );

                stockTrabajo = sucursalProducto?.stock || 0;

                if (stockTrabajo <= 0) {
                  mostrarProducto = false;
                }
              }
            }

            if (!mostrarProducto) {
              elementoHTML.style.display = "none";
              return;
            }

            const elementoCantidadInput = elementoHTML.querySelector(".ppme-modal-item-extra-cantidad");
            if (elementoCantidadInput) {
              elementoCantidadInput.setAttribute("max", stockTrabajo);
            }

            elementoHTML.style.display = "flex";
          });
        }
      }

      async editarProductosComplementarios() {
        let elClienteSiSelecciono = false;
        let itemsPedidos = [];

        // Configuración dinámica según la sección
        const configs = {
          postres: {
            contenedor: this.seccionModalExtrasPostres,
            itemsSeleccionados: "itemsSeleccionadoPostres",
            estadoItems: this.estadoItemsContenedorPostres,
            anadirMas: this.anadirMasContenedorPostres,
            estadoVacio: this.estadoVacioContenedorPostres,
            btnsEliminar: "btnsEliminarExtrasPostres",
          },
          gaseosas: {
            contenedor: this.seccionModalExtrasGaseosas,
            itemsSeleccionados: "itemsSeleccionadoGaseosas",
            estadoItems: this.estadoItemsContenedorGaseosas,
            anadirMas: this.anadirMasContenedorGaseosas,
            estadoVacio: this.estadoVacioContenedorGaseosas,
            btnsEliminar: "btnsEliminarExtrasGaseosas",
          },
        };

        const config = configs[this.cualSeccionExtrasEs];
        if (!config) return;

        const productosDisponibles = config.contenedor?.querySelectorAll(
          ".ppme-modal-item-extra"
        );

        const productosTrabajo = this.productosComplementarios.find(
          (coleccion) =>
            coleccion.nombre.toLowerCase() ==
            this.cualSeccionExtrasEs.toLowerCase()
        );

        if (productosDisponibles) {
          productosDisponibles.forEach((productoHTML) => {
            if (productoHTML.style.display === "none") return;
            const productoEncontrado = productosTrabajo.productos.find(
              (producto) =>
                producto.idshopify ==
                productoHTML.getAttribute("data-idshopify")
            );

            const cantidadElement = productoHTML.querySelector(
              "#phpd-cantidad-extras"
            );
            const imagenElement = productoHTML.querySelector(
              ".ppme-modal-item-extra-imagen img"
            );

            const idTrabajo = productoHTML.getAttribute("data-idtrabajo");
            const idShopify = productoHTML.getAttribute("data-idshopify");
            const cantidad = cantidadElement?.innerHTML || "1";
            const coleccion = productoHTML.getAttribute("data-coleccion");
            const titulo = productoHTML.getAttribute("data-titulo");
            const precio = productoHTML.getAttribute("data-precio");
            const imagen = imagenElement?.getAttribute("src") || "";

            // Validar cantidad - si no tiene cantidad válida, saltar
            if (!(parseInt(cantidadElement?.innerHTML) > 0)) return;

            elClienteSiSelecciono = true;
            productoEncontrado.cantidad = cantidad;
            itemsPedidos.push(productoEncontrado);
          });

          // Asignar items seleccionados dinámicamente
          this[config.itemsSeleccionados] = itemsPedidos;

          if (elClienteSiSelecciono) {
            let contenidoHTML = "";

            itemsPedidos.forEach((producto) => {
              contenidoHTML += `
                        <div 
                            data-coleccion="${this.cualSeccionExtrasEs}"
                            data-handle="${producto.handle || ""}"
                            data-idtrabajo="${producto.idtrabajo || ""}"
                            data-idshopify="${producto.idshopify || ""}"
                            data-cantidad="${producto.cantidad || "1"}"
                            data-titulo="${producto.nombre || ""}"
                            data-precio="${producto.precio || 0}"
                            data-precio-comparacion="${producto.precio_comparacion || 0
                }"
                            id="pmp-item-extra" 
                            class="pmp-item-extra-seleccionado">
                            <div class="pmp-item-extra-imagen">
                                <img src="${producto.imagen}" alt="${producto.nombre
                }" width="100%" height="100%">
                            </div>
                            <div class="pmp-item-extra-info">
                                <div class="pmp-item-extra-detalle">
                                    <p>x${producto.cantidad}</p>
                                    <p>${producto.nombre}</p>
                                    <p>${producto.precio}</p>
                                </div>
                                <button
                                    data-extras="${this.cualSeccionExtrasEs}"
                                    class="pmp-item-extra-delete icon-color-primary"
                                    type="button">
                                    ${window.shopIcons?.icon_basura || "🗑️"}
                                </button>
                            </div>
                        </div>
              `;
            });

            // Actualizar interfaz dinámicamente
            config.estadoItems.innerHTML = contenidoHTML;
            config.estadoItems.style.display = "flex";
            config.anadirMas.style.display = "flex";
            config.estadoVacio.style.display = "none";
          }

          // Configurar eventos de eliminación dinámicamente
          this[config.btnsEliminar] = config.estadoItems.querySelectorAll(
            ".pmp-item-extra-delete"
          );
          this[config.btnsEliminar].forEach((btnEliminar) => {
            btnEliminar.addEventListener(
              "click",
              this.eliminarItemExtras.bind(this, btnEliminar)
            );
          });
        }

        // Cerrar modal
        this.verProductosEspeciales("", "");
        await this.actualizarEstadoBotonesInferiores();
      }

      async procesoElegirLadoMitadYMitad(elementoHTML) {
        try {
          // 1. OBTENER INFORMACIÓN DEL ELEMENTO SELECCIONADO
          const elementoPadre = elementoHTML.closest(
            ".ppme-modal-items-pizzamitadymitad"
          );
          const elementoContenedor = elementoHTML.closest(".producto-item");

          // Validar que se encontraron los elementos necesarios
          if (!elementoPadre || !elementoContenedor) {
            console.error("No se encontraron los elementos padre necesarios");
            return;
          }

          // Obtener datos del producto seleccionado
          const cualLadoDeMitadYMitad =
            elementoPadre.getAttribute("lado-pizza");
          const tituloProducto = elementoContenedor.getAttribute("data-titulo");
          const idTrabajo = elementoContenedor.getAttribute("data-idtrabajo");

          // Validar datos obtenidos
          if (!cualLadoDeMitadYMitad || !tituloProducto || !idTrabajo) {
            console.error("Faltan datos necesarios del producto seleccionado");
            return;
          }

          // 2. PROCESAR LADO IZQUIERDO
          if (cualLadoDeMitadYMitad == "izquierda") {
            // Buscar el producto en los datos del lado izquierdo
            this.infoPizzaLIMM = this.productosLIMM.productos.find(
              (producto) => {
                return (
                  producto.id == idTrabajo && producto.titulo == tituloProducto
                );
              }
            );

            // Validar que se encontró el producto
            if (!this.infoPizzaLIMM) {
              console.error("No se encontró el producto para lado izquierdo");
              return;
            }

            // Actualizar botón del lado izquierdo
            this.btnModalLIMM.classList.add("seleccionado");
            const contenedorEtiquetaLIMM = this.btnModalLIMM.querySelector(
              ".pmph-extras-detalle"
            );
            if (contenedorEtiquetaLIMM) {
              contenedorEtiquetaLIMM.innerHTML = `<p>LADO IZQUIERDO</p><p>${tituloProducto}</p>`;
            }

            // Actualizar imagen del lado izquierdo
            this.imagenProductoBtnLIMM.classList.add("seleccionado");
            const iconoImagenBtnLIMM =
              this.imagenProductoBtnLIMM.querySelector(".phmp-psm-icon");
            if (iconoImagenBtnLIMM) {
              iconoImagenBtnLIMM.innerHTML =
                window.shopIcons.icon_estado_on_plus;
            }

            // Configurar imagen del producto lado izquierdo
            const imagenLIMM = this.imagenProductoLIMM.querySelector("img");
            if (imagenLIMM) {
              // Prioridad: urlImage2 > imagen > imagen por defecto
              if (
                this.infoPizzaLIMM.urlImage2 &&
                this.infoPizzaLIMM.urlImage2.trim() !== ""
              ) {
                imagenLIMM.src = this.infoPizzaLIMM.urlImage2;
              } else {
                imagenLIMM.src = window.assets.imagen_aux_mitadYmitad1;
              }
              imagenLIMM.alt = tituloProducto;
              imagenLIMM.style.visibility = "visible";
            }
          }

          // 3. PROCESAR LADO DERECHO
          else if (cualLadoDeMitadYMitad == "derecha") {
            // Buscar el producto en los datos del lado derecho
            this.infoPizzaLDMM = this.productosLDMM.productos.find(
              (producto) => {
                return (
                  producto.id == idTrabajo && producto.titulo == tituloProducto
                );
              }
            );

            // Validar que se encontró el producto
            if (!this.infoPizzaLDMM) {
              console.error("No se encontró el producto para lado derecho");
              return;
            }

            // Actualizar botón del lado derecho
            this.btnModalLDMM.classList.add("seleccionado");
            const contenedorEtiquetaLDMM = this.btnModalLDMM.querySelector(
              ".pmph-extras-detalle"
            );
            if (contenedorEtiquetaLDMM) {
              contenedorEtiquetaLDMM.innerHTML = `<p>LADO DERECHO</p><p>${tituloProducto}</p>`;
            }

            // Actualizar imagen del lado derecho
            this.imagenProductoBtnLDMM.classList.add("seleccionado");
            const iconoImagenBtnLDMM =
              this.imagenProductoBtnLDMM.querySelector(".phmp-psm-icon");
            if (iconoImagenBtnLDMM) {
              iconoImagenBtnLDMM.innerHTML =
                window.shopIcons.icon_estado_on_plus;
            }

            // Configurar imagen del producto lado derecho
            const imagenLDMM = this.imagenProductoLDMM.querySelector("img");
            if (imagenLDMM) {
              // Prioridad: imagen_secundaria > imagen > imagen por defecto
              if (
                this.infoPizzaLDMM.urlImage2 &&
                this.infoPizzaLDMM.urlImage2.trim() !== ""
              ) {
                imagenLDMM.src = this.infoPizzaLDMM.urlImage2;
              } else {
                imagenLDMM.src = window.assets.imagen_aux_mitadYmitad1;
              }
              imagenLDMM.alt = tituloProducto;
              imagenLDMM.style.visibility = "visible";
            }
          }

          // 4. LADO NO VÁLIDO
          else {
            console.error("Lado de pizza no válido:", cualLadoDeMitadYMitad);
            return;
          }

          // 5. CERRAR MODAL DE SELECCIÓN
          this.verProductosEspeciales("", "");

          // 6. ACTUALIZACION DE LOS PRECIOS EN TOTALES
          await this.actualizarEstadoBotonesInferiores();
        } catch (error) {
          console.error("Error en procesoElegirLadoMitadYMitad:", error);
        }
      }

      // METODOS GENERALES DEL CRUD (POSTRES - GASEOSAS - MITAD Y MITAD)
      verProductosEspeciales(tipoProductos, tipoDeLado) {
        // Primero verificar si el modal esta abierto o cerrado
        if (this.modalProductoExtras.style.display == "flex") {
          // Si el modal esta abierto, se cierra
          this.modalProductoExtras.style.display = "none";
        } else {
          if (tipoProductos == "postres") {
            this.btnSeccionModalGuardar.style.display = "flex";
            this.seccionModalExtrasGaseosas.style.display = "none";
            this.seccionBaseLadosMitadYMitad.style.display = "none";
            this.seccionModalExtrasPostres.style.display = "flex";
            this.estadoTrabajoComplementarios = "postres";
            this.cualSeccionExtrasEs = "postres";
          } else if (tipoProductos == "gaseosas") {
            this.btnSeccionModalGuardar.style.display = "flex";
            this.seccionModalExtrasGaseosas.style.display = "flex";
            this.seccionBaseLadosMitadYMitad.style.display = "none";
            this.seccionModalExtrasPostres.style.display = "none";
            this.estadoTrabajoComplementarios = "gaseosas";
            this.cualSeccionExtrasEs = "gaseosas";
          } else if (tipoProductos == "mitadymitad") {
            this.btnSeccionModalGuardar.style.display = "none";
            this.seccionModalExtrasGaseosas.style.display = "none";
            this.seccionBaseLadosMitadYMitad.style.display = "flex";
            this.seccionModalExtrasPostres.style.display = "none";
            this.estadoTrabajoComplementarios = "mitadymitad";
            if (tipoDeLado == "LIMM") {
              this.seccionModalExtrasLIMM.style.display = "grid";
              this.seccionModalExtrasLDMM.style.display = "none";
            } else if (tipoDeLado == "LDMM") {
              this.seccionModalExtrasLDMM.style.display = "grid";
              this.seccionModalExtrasLIMM.style.display = "none";
            }
          }

          this.modalProductoExtras.style.display = "flex";
        }
      }
    }
  );
}
